import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initAnalytics } from './lib/analytics';
import './styles/index.css';

// No-ops unless VITE_POSTHOG_KEY is set, which keeps local dev and the test
// suite silent without any mocking.
initAnalytics();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
